<template>
  <!-- 全部跟进：全量客户跟进记录，不做数据权限过滤（sceneType 不传） -->
  <FollowUpList :show-create="true" :show-tabs="false" />
</template>

<script lang="ts" setup>
import FollowUpList from '../components/FollowUpList.vue'

defineOptions({ name: 'CrmFollowUpAll' })
</script>
